import moment from 'moment';
import 'moment-timezone';
import { googleColors, hAxisUnits } from '../../../constants/analytics.constants';
import { getChartAxis, getChartMax, getChartTicks } from '../../../utils/chartHelper';
import { barChartOptions } from './constants';
import { formatFloat } from '../../../utils/number';

export const getChartData = (
  graphContent,
  chartHeader,
  timezone,
  colored = false,
  customColors = false,
  customFormat = false,
  isShowTotal
) => {
  return [
    ['Timestamp', { type: 'string', role: 'tooltip', p: { html: true } }, ...chartHeader],
    ...(graphContent.length !== 0 && graphContent[0].length === chartHeader.length + 1
      ? graphContent.map((graph, index) => {
          const date = moment.tz(graph[0], timezone).format('MMM D, YYYY, HH:mm:ss');
          let total = 0;
          
          return [
            index,
            `<div class="chart-tooltip">${date}${`${graph
              .slice(1)
              .map((content, index) => [chartHeader[index], content, index])
              .sort((x, y) => {
                return y[1] - x[1];
              })
              .map((content) => {
                if (isShowTotal) {
                  total += content[1];
                }
                return `<div class="chart-tooltip__content">${
                  colored
                    ? `<div class="chart-tooltip__color" style="background-color: ${
                        customColors ? customColors[content[2]] : googleColors[content[2]]
                      };"></div>`
                    : ''
                }${content[0]}:&nbsp<b>${customFormat ? customFormat(content[1]) : content[1]} </b></div>`;
              })}`.replaceAll(',', '')} ${
              isShowTotal
                ? `Total ${customFormat ? customFormat(formatFloat(total)) : formatFloat(total)}`
                : ''
            }</div>`,
            ...graph.slice(1),
          ];
        })
      : [[0, '', ...chartHeader.map(() => 0)]]),
  ];
};

export const checkGraph = graph => {
  return graph && graph.length !== 0;
};

export const getOptions = (graphContent, dates, mobile, customOptions, customColors) => {
  let maxGraph = Math.max(
    ...(graphContent
      .map((item) =>
        item.slice(1).reduce(function (sum, elem) {
          return sum + Number(elem);
        }, 0)
      )
      .flat() || 100)
  );
  
  const ticks = getChartTicks({
    content: graphContent,
    timezone:  dates[4],
    tickValueFormat: 'number',
  });
  
  return {
    colors: customColors ? customColors : googleColors,
    tooltip: { isHtml: true, trigger: mobile ? 'selection' : 'focus' },
    hAxis: {
      allowContainerBoundaryTextCutoff: true,
      ticks,
      slantedText: false,
      maxAlternation: 1,
      baselineColor: 'transparent',
      gridlines: {
        color: 'none',
        ...hAxisUnits,
      },
      minorGridlines: {
        count: 0,
        ...hAxisUnits,
      },
    },
    vAxis: {
      allowContainerBoundaryTextCutoff: true,
      maxTextLines: 1,
      ticks: getChartAxis(maxGraph),
      minorGridlines: {
        count: 0,
      },
      viewWindow: {
        min: 0,
        max: getChartMax(maxGraph),
      },
      minValue: 0,
      maxValue: getChartMax(maxGraph),
    },
    chartArea: {
      left: mobile ? 25 : 35,
      bottom: 24,
      top: 24,
      right: mobile ? 12 : 20,
    },
    ...barChartOptions,
    ...customOptions,
  };
};
